import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class factor extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  saveFactorInfo(data) {
    return this.httpService.post("Project/factor-unit-string", data, {
      headers,
    });
  }

  getFactorModels(params) {
    return this.httpService.get("Account/combo-model-factor", {
      headers,
      params,
    });
  }

  getFactorDefaultCost(params) {
    return this.httpService.get("Project/cost-default-factor", {
      headers,
      params,
    });
  }

  getGrouhMoshtariWithAdmin(params) {
    return this.httpService.get("Definition/combo-group-customer", {
      headers,
      params,
    });
  }

  saveFactorPrice(data) {
    return this.httpService.post("Project/factor-unit", data, { headers });
  }

  postInfoUnitConvert(data) {
    return this.httpService.post("Project/info-units", data, { headers });
  }

  getTemplateForConvert(params) {
    return this.httpService.get("Definition/list-convert-template", {
      headers,
      params,
    });
  }

  getGlassForConvert(params) {
    return this.httpService.get("Definition/combo-product-glass-id", {
      headers,
      params,
    });
  }

  getNetForConvert(params) {
    return this.httpService.get("Definition/combo-net-id", { headers, params });
  }
  getPopForConvert(params) {
    return this.httpService.get("Definition/combo-pop-with-id-convert", {
      headers,
      params,
    });
  }

  getProfileForConvert(params) {
    return this.httpService.get("Definition/get-product-convert-id", {
      headers,
      params,
    });
  }

  saveArchiveFactor(data) {
    return this.httpService.post("Project/save-factor", data, { headers });
  }

  getListArchiveFactorProject(params) {
    return this.httpService.get("Project/list-price-archive-factor", {
      headers,
      params,
    });
  }

  shoFactorArchive(data) {
    return this.httpService.post("Project/factor-unit-archive-string", data, {
      headers,
    });
  }

  getComboKhadamat(params) {
    return this.httpService.get("Definition/combo-khadamat", {
      headers,
      params,
    });
  }

  getCalcKhedmat(data) {
    return this.httpService.post("Project/calc-khedmat-factor", data, {
      headers,
    });
  }

  getUnitListWithImg(params) {
    return this.httpService.get("Project/list-unit-designer-with-image", {
      headers,
      params,
    });
  }
}

const FactorService = new factor();
export default FactorService;
